/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2021
 * @flow
 */

import React, { useEffect, useRef, useState } from 'react';
import styles from './BulletButton.module.css';

const BulletButton = props => {
  const {
    direction,
    triangleBgColor,
    children,
    subBtnText,
    onClick,
    disabled,
    buttonStyle,
  } = props;
  const [height, setHeight] = useState(0);
  let containerStyle = {};
  let buttonBorderStyle = styles.rightButtonStyle;
  if (direction === 'left') {
    containerStyle = { flexDirection: 'row-reverse' };
    buttonBorderStyle = styles.leftButtonStyle;
  }
  const disabledStyle = disabled ? { opacity: 0.5 } : {};

  const buttonRef = useRef(null);

  useEffect(() => {
    if (buttonRef && buttonRef.current && buttonRef.current.offsetHeight) {
      setHeight(buttonRef.current.offsetHeight);
    }
  }, []);

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      style={{ ...disabledStyle, ...containerStyle }}
      className={styles.bulletBtnDiv}
    >
      <div className={[buttonBorderStyle, styles.bulletBtn, buttonStyle].join(' ')} ref={buttonRef}>
        {children}
        {subBtnText ? (
          <div className={styles.subBtnText}>
            {subBtnText}
          </div>
        ) : null}
      </div>
      <Triangle triangleBgColor={triangleBgColor} direction={direction} height={height} />
    </button>
  );
}

const Triangle = ({ triangleBgColor = 'lightgray', direction, height }) => {
  const buttonHeight = height || 66;
  const rightTriangle = {
    borderTopWidth: buttonHeight / 2,
    borderBottomWidth: buttonHeight / 2,
    borderLeftWidth: buttonHeight / 2.5,
    borderLeftColor: 'black',
  };
  const LeftTriangle = {
    borderTopWidth: buttonHeight / 2,
    borderBottomWidth: buttonHeight / 2,
    borderRightWidth: buttonHeight / 2.5,
    borderLeftColor: 'black',
  };
  const directionStyle =
    direction === 'right'
      ? {
        ...rightTriangle,
        borderLeftColor: triangleBgColor,
      }
      : { ...LeftTriangle, borderRightColor: triangleBgColor };
  const triangle = {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: 'transparent',
    borderTopColor: 'transparent',
  }
  return <div style={{ ...triangle, ...directionStyle }}></div>
};

export default BulletButton;
